import { State } from "../../interfaces/State";
import { RouteComponentProps} from "react-router-dom";

interface IProps {
    id?: string;
}

export const getUser = (state : State, props : RouteComponentProps<IProps>) => {
    return state.users.find(user => user.id == parseInt(props.match.params.id));
}